import React from 'react'

export const SkeletonCard = () => {
  return (
    <div className="card p-6 animate-pulse">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className="h-4 bg-gray-200 rounded w-24 mb-3"></div>
          <div className="h-8 bg-gray-200 rounded w-16 mb-2"></div>
        </div>
        <div className="flex-shrink-0">
          <div className="w-16 h-16 bg-gray-200 rounded-xl"></div>
        </div>
      </div>
    </div>
  )
}

export const SkeletonTable = ({ rows = 5, columns = 5 }) => {
  return (
    <div className="overflow-x-auto animate-pulse">
      <table className="table">
        <thead>
          <tr>
            {Array.from({ length: columns }).map((_, i) => (
              <th key={i}>
                <div className="h-4 bg-gray-200 rounded w-20"></div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr key={rowIndex}>
              {Array.from({ length: columns }).map((_, colIndex) => (
                <td key={colIndex}>
                  <div className="h-4 bg-gray-200 rounded w-full"></div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export const SkeletonList = ({ items = 5 }) => {
  return (
    <div className="space-y-4">
      {Array.from({ length: items }).map((_, index) => (
        <div key={index} className="card p-4 animate-pulse">
          <div className="flex items-start space-x-4">
            <div className="w-12 h-12 bg-gray-200 rounded-lg flex-shrink-0"></div>
            <div className="flex-1 space-y-2">
              <div className="h-4 bg-gray-200 rounded w-3/4"></div>
              <div className="h-3 bg-gray-200 rounded w-1/2"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export const SkeletonGrid = ({ items = 6 }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {Array.from({ length: items }).map((_, index) => (
        <div key={index} className="card p-6 animate-pulse">
          <div className="w-full h-40 bg-gray-200 rounded-lg mb-4"></div>
          <div className="h-5 bg-gray-200 rounded w-3/4 mb-2"></div>
          <div className="h-4 bg-gray-200 rounded w-1/2"></div>
        </div>
      ))}
    </div>
  )
}

// Skeleton for Offline Tests - matches the exact table structure
export const SkeletonOfflineTests = ({ rows = 6 }) => {
  return (
    <div className="overflow-x-auto animate-pulse">
      <table className="w-full border-collapse">
        <thead>
          <tr className="border-b border-gray-200">
            <th className="text-left py-3 px-4 font-medium text-gray-600 uppercase text-sm">
              <div className="h-4 bg-gray-200 rounded w-24"></div>
            </th>
            <th className="text-left py-3 px-4 font-medium text-gray-600 uppercase text-sm">
              <div className="h-4 bg-gray-200 rounded w-20 mx-auto"></div>
            </th>
            <th className="text-left py-3 px-4 font-medium text-gray-600 uppercase text-sm">
              <div className="h-4 bg-gray-200 rounded w-16 mx-auto"></div>
            </th>
            <th className="text-left py-3 px-4 font-medium text-gray-600 uppercase text-sm">
              <div className="h-4 bg-gray-200 rounded w-20 mx-auto"></div>
            </th>
            <th className="text-left py-3 px-4 font-medium text-gray-600 uppercase text-sm">
              <div className="h-4 bg-gray-200 rounded w-16 mx-auto"></div>
            </th>
            <th className="text-left py-3 px-4 font-medium text-gray-600 uppercase text-sm">
              <div className="h-4 bg-gray-200 rounded w-20 mx-auto"></div>
            </th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr key={rowIndex} className="border-b border-gray-100 hover:bg-gray-50">
              {/* Test Details Column - Image + Title */}
              <td className="py-4 px-4">
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 bg-gray-200 rounded-lg flex-shrink-0"></div>
                  <div className="space-y-2 flex-1">
                    <div className="h-4 bg-gray-200 rounded w-32"></div>
                    <div className="h-3 bg-gray-200 rounded w-24"></div>
                  </div>
                </div>
              </td>
              {/* Tests Count */}
              <td className="py-4 px-4 text-left">
                <div className="flex items-center justify-center space-x-1">
                  <div className="h-4 w-4 bg-gray-200 rounded"></div>
                  <div className="h-4 bg-gray-200 rounded w-8"></div>
                </div>
              </td>
              {/* Plan */}
              <td className="py-4 px-4 text-left">
                <div className="h-4 bg-gray-200 rounded w-12 mx-auto"></div>
              </td>
              {/* Add Test Button */}
              <td className="py-4 px-4 text-left">
                <div className="w-8 h-8 bg-gray-200 rounded-full mx-auto"></div>
              </td>
              {/* Date */}
              <td className="py-4 px-4 text-left">
                <div className="h-4 bg-gray-200 rounded w-20 mx-auto"></div>
              </td>
              {/* Actions */}
              <td className="py-4 px-4">
                <div className="flex items-center justify-center space-x-2">
                  <div className="w-6 h-6 bg-gray-200 rounded"></div>
                  <div className="w-6 h-6 bg-gray-200 rounded"></div>
                  <div className="w-6 h-6 bg-gray-200 rounded"></div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default SkeletonCard
